import React from 'react';
import type {
  AssetDetailViewProps,
} from '@plerionhq/design-system';
import { withErrorBoundary } from '../../../hoc/withErrorBoundary';

const AssetDetail = withErrorBoundary(
  React.lazy(() => import('../../../micro-frontends/components/AssetDetail')),
);

export const AssetDetailView = (props: AssetDetailViewProps) => {
  return <AssetDetail {...(props.data as any)} />;
};
